<template>
<div class="map-wrapper">
  <div v-if="showMap" style="width : 100%;" :style="mapStyle">
    <v-map ref="semap" :zoom="zoomLevel" :center="[centerLangPosition, centerLongPosition]" v-on:l-zoomend="({target: {_zoom: v}}) => zoom = v">
      <v-tilelayer url="https://{s}.tile.osm.org/{z}/{x}/{y}.png" :attribution="attribution"></v-tilelayer>
      <v-marker v-if="showMarker" :draggable="false" :lat-lng="[markerLangPosition, markerLongPosition]">
        <!-- <v-tooltip :content="content"></v-tooltip> -->
        <v-popup v-if="caption" :content="content"></v-popup>
      </v-marker>
    </v-map>
  </div>
</div>
</template>
<script>
import { calculateHeight, ReplaceBackslashNtoBr } from '@/modules/helper/index'
export default {
  props: {
    caption: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    showMarker: {
      type: Boolean,
      default: true
    },
    centerLangPosition: {
      type: String,
      default: '0'
    },
    centerLongPosition: {
      type: String,
      default: '0'
    },
    markerLangPosition: {
      type: String,
      default: '0'
    },
    markerLongPosition: {
      type: String,
      default: '0'
    },
    zoomLevel: {
      type: Number,
      default: 13
    },
    mapHeight: {
      type: String,
      default: 'medium'
    },
    attribution: {
      type: String,
      default: '&copy; <a href="https://osm.org/copyright">OpenStreetMap</a>'
    }
  },
  data() {
    return {
      showMap: true
    }
  },
  computed: {
    mapStyle() {
      let Height = calculateHeight(this.mapHeight)
      return {
        'height': `${Height}px`
      }
    },
    content() {
      return '<b>' + this.caption + ' </b><br>' + ReplaceBackslashNtoBr(this.description)
    }
  },
  watch: {
    mapHeight: function(value) {
      this.showMap = false
      this.$nextTick(() => {
        this.showMap = true
      })
    }
  },
  mounted() {
    this.disableScrollAndDrag()
  },
  updated() {
    this.disableScrollAndDrag()
  },
  methods: {
    disableScrollAndDrag() {
      if (this.$refs.semap) {
        let mapObject = this.$refs.semap.mapObject
        mapObject.on('popupopen', () => {
          var closeElement = document.getElementsByClassName("leaflet-popup-close-button");
          closeElement[0].href = ""
        });
        if (mapObject.dragging) {
          mapObject.dragging.removeHooks()
        }
        if (mapObject.scrollWheelZoom) {
          mapObject.scrollWheelZoom.removeHooks()
        }
      }
    }
  }
}
</script>
<style>
  /* .map-wrapper {
    padding: 10px 0px!important;
  } */

  .leaflet-popup-content-wrapper{
    max-width: 200px !important;
    word-wrap: break-word !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/stacked-elements/content-control/Map.vue